import script from "./ProfileProjectsAsLeaderItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileProjectsAsLeaderItem.vue?vue&type=script&setup=true&lang=js"

import "./ProfileProjectsAsLeaderItem.vue?vue&type=style&index=0&id=5efecf92&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5efecf92"]])

export default __exports__